import React from 'react'
import shots from '@/images/shots-compressed.mp4'

const Hero = () => {
  return (
    <div className="container max-w-xl px-4 mx-auto mb-4">
      <div className="w-32 mx-auto ">
        <video autoPlay muted loop controls src={shots} />
      </div>
      <h2 className="mt-4 mb-8 text-5xl text-center">
        El mapa definitivo de la violencia en la Macrozona sur
      </h2>
      <p className="text-xl text-center">
        ¿Cuáles han sido los puntos críticos de los más graves atentados
        ocurridos en el Biobío y La Araucanía durante los últimos cinco años?
        Tras un análisis de las más de 500 querellas presentadas por el
        gobierno, este mapa visualiza la expansión de una violencia que parece
        no tener fin.
      </p>
      <hr className="mb-4" />
      <p className="mb-4 text-center font-actasans">
        Por <strong>Sebastián Labrín y Felipe Díaz</strong>
      </p>
      <div className="content">
        <p className="firstLetter">
          Los números son desalentadores. Con un promedio de{' '}
          <strong>nueve ataques cada 30 días</strong> en los últimos cinco años,
          los hechos de violencia en la zona roja del conflicto mapuche que
          afecta a las regiones del Biobío y La Araucanía se ha transformado en
          un tema complejo para el gobierno, las fiscalías y las policías.
        </p>
        <p>
          No solo por los crecientes niveles de inseguridad en las rutas y por
          el temor de sus habitantes, sino que, además, por los escasos
          resultados que han obtenidos las investigaciones del{' '}
          <strong>Ministerio Público</strong> por hechos tan graves como
          atentados incendiarios contra iglesias, empresas forestales, quemas de
          viviendas y ataques armados contra conductores en caminos rurales de
          la región.{' '}
        </p>
        <p>
          Frente a la escala de violencia ocurrida en las últimas semanas en la
          zona, el equipo de <strong>Investigación y Datos</strong> de{' '}
          <strong>La Tercera</strong> analizó las cerca de{' '}
          <strong>mil querellas</strong> presentadas por el gobierno entre{' '}
          <strong>2016 y 2021</strong> en las regiones de La Araucanía y el
          Biobío, de las cuales <strong>547</strong> acciones legales denuncian
          ataques en contexto de la llamada violencia rural.
        </p>
        <h3 className="my-8 text-center destacado">
          Esta fue la base para elaborar un mapa georreferenciado de cada uno de
          estos ataques y que exhibe por primera vez, a este nivel de detalle,
          cómo los atentados se fueron multiplicando por los distintos rincones
          de la zona.  
        </h3>
        <p>
          Es así que se encuentran denuncias presentadas tanto en el segundo
          gobierno de la expresidenta <strong>Michelle Bachelet</strong> por
          atentados explosivos, homicidios, quemas de casas y de maquinarias,
          como también acciones legales dentro del segundo mandato del
          Presidente <strong>Sebastián Piñera</strong> por robos con
          intimidación y balaceras en las rutas. Los registros judiciales
          muestran un dramático resultado: 40 comunas son foco constante de
          violencia, donde la curva de atentados crece de manera inversa a la de
          los detenidos por cometer estos delitos.
        </p>
        <p>
          Ante los magros avances, la <strong>PDI</strong>, principal policía
          que investiga los hechos más graves de violencia rural, realizó
          cambios en su estrategia: de manera extraoficial los detectives hablan
          de una “poda”, que en términos simples significa seguir de cerca a
          sospechosos de cometer o liderar atentados para detenerlos cuando
          cometan delitos comunes, ya que para los investigadores no es inusual
          el vínculo que existe entre la <strong>violencia rural</strong> y
          otros hechos criminales.
        </p>
        <p>
          Los atentados, robos violentos y quemas son agrupados bajo la etiqueta
          de “violencia rural”, la cual no tiene un{' '}
          <strong>registro único y oficial</strong> en el gobierno, las
          fiscalías o las policías. Y al igual que ocurre con otros fenómenos
          delictuales, cada institución lleva su propio catastro de los delitos
          ocurridos en la zona roja del conflicto mapuche. Mientras algunos
          personeros incluyen en sus estadísticas y resultados los arrestos por
          usurpaciones de terrenos, otros optan por no considerar estos hechos
          como violencia rural.{' '}
        </p>
        <p>
          Estos son los principales resultados de la investigación.{' '}
          <a
            className="text-black underline"
            href="https://www.latercera.com/investigacion-y-datos/noticia/la-metodologia-tras-la-elaboracion-del-mapa-de-la-violencia-en-la-macrozona-sur/WZBGXXQGR5AQNAZKDHNJCLQCNM/"
            target="_blank"
            rel="noreferrer noopener">
            Revisa el detalle de la metodología aquí.
          </a>{' '}
        </p>
      </div>
    </div>
  )
}

export default Hero
